import React, { ButtonHTMLAttributes, JSX, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LuCalendarDays } from 'react-icons/lu'
import { Box, Text } from '@chakra-ui/react'

import { getDateFormatLocale } from 'utils/getDateFormatLocale'

import { DateTimePickerContext } from '../../helpers'
import { VisibleSectionEnum } from '../../interfaces'

import { DateTimePickerButton, DateTimePickerButtonContent } from './styles'

export const DateButton = ({ ...buttonProps }: ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element => {
  const { dateTimeState, setDateTimeState } = useContext(DateTimePickerContext)
  const { t } = useTranslation(['common'])

  const {
    visibleSection,
    value: { day, month },
    props: { shouldDisableDateButton },
    isLoading,
  } = dateTimeState

  const showDateSection = () => {
    setDateTimeState((state) => ({ ...state, visibleSection: VisibleSectionEnum.DATE, isExpanded: true }))
  }

  const stylingProps = {
    isFocused: visibleSection === VisibleSectionEnum.DATE,
    isDisabled: isLoading || (shouldDisableDateButton ? shouldDisableDateButton(dateTimeState) : false),
  }

  return (
    <DateTimePickerButton onClick={showDateSection} {...stylingProps} {...buttonProps}>
      <Box marginRight="14px" flexGrow={0} color="green.a200">
        <LuCalendarDays size={20} />
      </Box>
      <DateTimePickerButtonContent marginRight="auto">
        <Text color="green.a200" fontWeight={700} fontSize="xxs">
          {t('date')}
        </Text>
        {typeof day !== 'number' || typeof month !== 'number' ? (
          <Text fontSize="sm" color="gray.400">
            {t('selectDay')}
          </Text>
        ) : (
          <Text fontSize="sm">
            {day} {getDateFormatLocale().localize?.month(month, { width: 'abbreviated' })}
          </Text>
        )}
      </DateTimePickerButtonContent>
    </DateTimePickerButton>
  )
}
